/**
 * Cards carousel – infinite loop (techhunk.pk clone-band technique)
 * Clones cards head/tail; edge-fix jumps keep scroll infinite without rewind jerk.
 */
(function () {
  const SECTION_SELECTOR = '.cards-carousel[data-section-id]';

  function setScrollInstant(track, left) {
    const prev = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = left;
    track.style.scrollBehavior = prev || 'smooth';
  }

  function initCarousel(section) {
    const track = section.querySelector('.cards-carousel__track');
    if (!track || track.dataset.carouselReady === 'true') return;

    const gap = parseFloat(track.dataset.gap || '0', 10);
    const autoplay = track.dataset.autoplay === 'true';
    const intervalSec = parseInt(track.dataset.interval || '4', 10);
    const pauseOnHover = track.dataset.pauseHover === 'true';

    const originals = Array.from(
      track.querySelectorAll('.cards-carousel__card:not(.cards-carousel__card--clone)')
    );
    const origCount = originals.length;
    if (origCount <= 1) {
      if (autoplay && origCount === 1) return;
      track.dataset.carouselReady = 'true';
      return;
    }

    let origWidth = 0;
    let initialized = false;
    let edgeTimer = null;
    let autoTimer = null;

    function measureOriginalWidth() {
      const cards = Array.from(track.querySelectorAll('.cards-carousel__card:not(.cards-carousel__card--clone)')).slice(
        0,
        origCount
      );
      let total = 0;
      cards.forEach((card, index) => {
        total += card.offsetWidth;
        if (index < cards.length - 1) total += gap;
      });
      origWidth = total;
    }

    function buildInfinite() {
      if (initialized) return;

      track.querySelectorAll('.cards-carousel__card--clone').forEach((node) => node.remove());

      const cards = Array.from(
        track.querySelectorAll('.cards-carousel__card:not(.cards-carousel__card--clone)')
      ).slice(0, origCount);

      cards.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.classList.add('cards-carousel__card--clone');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
          el.removeAttribute('data-shopify-editor-block');
        });
        track.appendChild(clone);
      });

      for (let i = cards.length - 1; i >= 0; i -= 1) {
        const clone = cards[i].cloneNode(true);
        clone.classList.add('cards-carousel__card--clone');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
          el.removeAttribute('data-shopify-editor-block');
        });
        track.insertBefore(clone, track.firstChild);
      }

      measureOriginalWidth();
      setScrollInstant(track, origWidth);
      initialized = true;
    }

    function stepSize() {
      const card = track.querySelector('.cards-carousel__card:not(.cards-carousel__card--clone)');
      return card ? card.offsetWidth + gap : 0;
    }

    function edgeFix() {
      if (!initialized || !origWidth) return;
      const x = track.scrollLeft;
      const buffer = origWidth * 0.05;
      const rightLimit = origWidth * 2 - track.clientWidth - buffer;

      if (x < buffer) {
        setScrollInstant(track, x + origWidth);
      } else if (x > rightLimit) {
        setScrollInstant(track, x - origWidth);
      }
    }

    function scheduleEdgeFix() {
      if (!initialized) return;
      clearTimeout(edgeTimer);
      edgeTimer = setTimeout(edgeFix, 40);
    }

    function scrollNext() {
      const step = stepSize();
      if (!step) return;
      track.scrollBy({ left: step, behavior: 'smooth' });
      scheduleEdgeFix();
    }

    function startAuto() {
      if (!autoplay || autoTimer) return;
      autoTimer = setInterval(scrollNext, Math.max(2, intervalSec) * 1000);
    }

    function stopAuto() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function init() {
      measureOriginalWidth();
      buildInfinite();
      startAuto();
      track.dataset.carouselReady = 'true';
    }

    if (pauseOnHover) {
      track.addEventListener('mouseenter', stopAuto, { passive: true });
      track.addEventListener('mouseleave', startAuto, { passive: true });
    }

    track.addEventListener('scroll', scheduleEdgeFix, { passive: true });

    let resizeTimer;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (!initialized) return;
          const posInBand = track.scrollLeft % origWidth;
          measureOriginalWidth();
          setScrollInstant(track, origWidth + posInBand);
        }, 150);
      },
      { passive: true }
    );

    const imgs = track.querySelectorAll('img');
    let pending = 0;
    imgs.forEach((img) => {
      if (img.complete) return;
      pending += 1;
      img.addEventListener(
        'load',
        () => {
          pending -= 1;
          if (pending === 0) init();
        },
        { once: true }
      );
    });

    if (pending === 0) init();
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initCarousel(section);
    });
  }

  function boot() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector(SECTION_SELECTOR) ||
      event.target.closest(SECTION_SELECTOR);
    if (section) {
      const track = section.querySelector('.cards-carousel__track');
      if (track) {
        track.dataset.carouselReady = 'false';
        track.querySelectorAll('.cards-carousel__card--clone').forEach((node) => node.remove());
      }
      initCarousel(section);
    }
  });
})();
